import React, { forwardRef } from 'react';
import { Formik, FormikConfig, FormikProps, FormikValues } from 'formik';
import { mapObjIndexed, values, path, compose } from 'ramda';

import { getFormPath } from 'utils';
import { FormField } from './FormField';
import { FormFieldError } from './FormFieldError';

export const renderFieldError = error => error && <FormFieldError>{error}</FormFieldError>;

export const renderFormField = (name: string, value: any, field: any, { handleChange, handleBlur, errors }, checked?: boolean) => (
  <FormField
    name={name}
    value={value}
    checked={checked}
    onChange={handleChange}
    onBlur={handleBlur}
    error={path(getFormPath(name), errors)}
    {...field}
  />
);

const renderFields = (field: any, name: string, formProps: any) => renderFormField(name, undefined, field, formProps);

interface IFormProps extends FormikConfig<FormikValues> {
  fields?: any[];
  children: (formProps: Omit<FormikProps<FormikValues>, 'handleSubmit'>) => React.ReactNode;
}

export const Form = forwardRef(({ children, fields = [], ...props }: IFormProps, ref) => (
  <Formik ref={ref} {...props}>
    {({ handleSubmit, ...formProps }) => (
      <form onSubmit={handleSubmit}>
        {children(formProps)}
        {values(mapObjIndexed(renderFields, fields))}
      </form>
    )}
  </Formik>
));
